import React from "react"
import injectSheet from "react-jss"
import { Icon } from "@xingternal/360-components"

const styles = {
  navWrapper: {
    composes: "posa l0 t50 r0 petrol",
    zIndex: 100,
  },
  buttonBase: {
    composes: "p12 dib circle level2 cursor-pointer posa translatey-n-50",
  },
  buttonDefault: { composes: "$buttonBase background-white petrol-link" },
  buttonPrev: { composes: "$buttonDefault l0" },
  buttonNext: { composes: "$buttonDefault r0" },
  buttonDone: { composes: "$buttonBase r0 background-petrol-link white" },
  buttonIcon: { composes: "block" },
}

const CarouselNav = ({ classes, index, total, prevHandler, nextHandler }) => (
  <div className={classes.navWrapper}>
    <span
      className={classes.buttonPrev}
      style={{ transform: "translate(-50%, -50%)" }}
      onClick={prevHandler}
    >
      <Icon name="shape-arrow-left" size={16} className={classes.buttonIcon} />
    </span>
    <span
      className={classes.buttonNext}
      style={{ transform: "translate(50%, -50%)" }}
      onClick={nextHandler}
    >
      <Icon name="shape-arrow-right" size={16} className={classes.buttonIcon} />
    </span>
  </div>
)

const enhance = injectSheet(styles)

export default enhance(CarouselNav)
